module.exports = __webpack_public_path__ + "img/84600.c417bfe1.jpg";